import { render, staticRenderFns } from "./mobileDrinksLayout.vue?vue&type=template&id=9a1c56de&scoped=true&"
import script from "./mobileDrinksLayout.vue?vue&type=script&lang=js&"
export * from "./mobileDrinksLayout.vue?vue&type=script&lang=js&"
import style0 from "./mobileDrinksLayout.vue?vue&type=style&index=0&id=9a1c56de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a1c56de",
  null
  
)

export default component.exports